import { styled } from '@mui/material/styles';
import { forwardRef, ReactNode } from 'react';

const Root = styled('div')(() => ({
  minHeight: '100%'
}));

type FuseScrollbarsProps = {
  id?: string;
  className?: string;
  children: ReactNode;
};

const FuseScrollbars = forwardRef<HTMLDivElement, FuseScrollbarsProps>((props, ref) => {
  const { className = '', children, id = '' } = props;

  return (
    <Root id={id} className={className} ref={ref}>
      {children}
    </Root>
  );
});

export default FuseScrollbars;
